import axios from 'axios';
import type { BulkSupraLockboxProcessedResult } from './bulkCreateShacklePermissions';

const bulkUnassignSupraLockboxes = async ({
  lockboxAssigneeMap,
}: {
  lockboxAssigneeMap: Record<string, string>;
}): Promise<BulkSupraLockboxProcessedResult> => {
  const { data, status } = await axios.post<BulkSupraLockboxProcessedResult>(
    '/supra/lockbox/bulk_unassign_lockboxes',
    {
      lockboxAssigneeMap,
    },
  );

  if (status < 200 || status >= 300) {
    throw new Error(`Unexpected response status: ${status}`);
  }

  return data;
};

export default bulkUnassignSupraLockboxes;
